import {DeserializedRecord, deserializeItem, Deserializer} from "../Helpers";
import {RestrictionType} from "./icd10";

interface RestrictionManual extends DeserializedRecord {
  description: string;
  title: string;
  restrictionType: RestrictionType
}

const deserializeRestrictionManual: Deserializer<RestrictionManual> = (data) => ({
  ...deserializeItem(data)
});

export {
  deserializeRestrictionManual, RestrictionManual
};
